import * as types from "./mutation-type";

export default {
    [types.SET_TOKEN](state, payload) {
        state.token = payload
    }
}
